import React, {useState} from 'react';
import s from "./LinkedInPostPreview.module.css";
import menu from "../../../../assets/img/menu.svg";
import like from "../../../../assets/img/like_twitter.svg";
import comment from "../../../../assets/img/comment_twitter.svg";
import share from "../../../../assets/img/share.svg";
import save from "../../../../assets/img/save_twitter.svg";
import download from "../../../../assets/img/download_twitter.svg";

interface TwitterPostPreviewProps {
    image: string | null;
    text: string ;
    highlightHashtags:(text:string)=>void
}

const TwitterPostPreview: React.FC<TwitterPostPreviewProps> = ({image,text,highlightHashtags}) => {
    const [showFullText, setShowFullText] = useState<boolean>(false);

    return (
        <div className={s.preview}>
            <div className={s.profileSection}>
                <div style={{display: 'flex'}}>
                    <div className={s.profileImage}></div>
                    <div className={s.profileDetails}>
                        <div className={s.profileName}></div>
                        <div className={s.profileTitle}></div>

                    </div>
                </div>

                <img src={menu} className={s.menu} alt="Menu"/>
            </div>

            <div className={s.content}>
                <>
                    {highlightHashtags(text)}
                </>

            </div>
            {image &&
                <div className={s.imageListTwitter}>

                    <img src={image} className={s.uploadedImageTwitter}/>

                </div>}

            <div className={s.commentsSharesSection}>
                <div className={s.commentShareRow}>

                    <div className={s.details}>
                        <div className={s.twitter_text}>12:00 PM</div>
                        <div className={s.twitter_text}>•</div>
                        <div className={s.twitter_text}>Oct 14,2023</div>
                        <div className={s.twitter_text}>•</div>
                        <div className={s.twitter_text}>1K Views</div>
                    </div>
                </div>
                <div className={s.actionButtons}>
                    <div className={s.actionButton}>
                        <img src={comment} alt="Comment"/>
                        <p  className={s.twitter_text}>991</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={share} alt="Share"/>
                        <p  className={s.twitter_text}>100</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={like} alt="Like"/>
                        <p  className={s.twitter_text}>9,864</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={save} alt="Save"/>
                        <p  className={s.twitter_text}>90</p>
                    </div>
                    <div className={s.actionButton}>
                        <img src={download} alt="Download"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwitterPostPreview;
